import React from 'react';
import LoginLayout from '../components/layout/LoginLayout';
import Layout from '../components/layout/Layout';
import routes from '../configs/routes';
import { GUEST_MODULE, SYSTEM_MODULE } from '../configs/moduleNames';
import { APP_START_ROUTE, ROLE_TYPE } from '../configs';
import { sortLinksFunction } from './layout-utils';
import PermissionDeniedPage from '../modules/System/components/PermissionDeniedPage';
import { isRoleAllowedForPath, ROLE_ROUTE_ACCESS } from './roleAccess';

export { ROLE_ROUTE_ACCESS };

export const getUserRole = (state = {}) => {
  const role = [
    state?.data?.role,
    state?.role,
    state?.authorizedData?.data?.role,
    state?.authorizedData?.role,
  ].find(item => typeof item === 'number' || typeof item === 'string');
  return role ? Number(role) : null;
};

const isRouteAllowedByRole = (route = {}, loggedIn, state = {}) => {
  if (!loggedIn) {
    return true;
  }

  const currentRole = getUserRole(state);
  if (!currentRole && route.path === APP_START_ROUTE) {
    return true;
  }
  if (!currentRole) {
    return false;
  }

  return isRoleAllowedForPath(route.path, currentRole, route.allowedRoles);
};

export const filterRoutes = (routesList, loggedIn, permissions = {}, state = {}, isMobile) => [...routesList].reduce((acc, route = {}) => {
  const permissionList = typeof route.permission === 'string' ? [route.permission] : route.permission || [];
  const needLoggedIn = Boolean(loggedIn) === Boolean(route.loginRequired);
  const isGuestModule = permissionList.some(item => item === GUEST_MODULE);
  const permission = !!permissionList.every(routePermission => !!permissions[routePermission]);
  const isSystemModule = permissionList.some(item => item === SYSTEM_MODULE);
  let customFilter = true;
  if (route && route.filter && typeof route.filter === 'function') {
    customFilter = route.filter(state, route);
  }

  if (!needLoggedIn || !customFilter || !(permission || isGuestModule || isSystemModule)) {
    return acc;
  }

  const children = permission && route.children && route.children.length && loggedIn
    ? filterRoutes(route.children, loggedIn, permissions, state, isMobile)
    : route.children || [];
  const roleAllowed = isRouteAllowedByRole(route, loggedIn, state);
  const Component = roleAllowed ? route.component : PermissionDeniedPage;
  const resolvedRoute = {
    ...route,
    permission: permissionList,
    component: Component,
    hideOnMenu: roleAllowed ? route.hideOnMenu : true,
  };
  if (!route.index) {
    resolvedRoute.children = children;
  } else {
    delete resolvedRoute.children;
  }

  if (route && route.element && roleAllowed) {
    return [...acc, resolvedRoute];
  }

  return [...acc, { ...resolvedRoute, element: <Component /> }];
}, []);

export const getRouteByRole = (loggedIn, permissions = {}, state = {}, isMobile) => filterRoutes(routes, loggedIn, permissions, state, isMobile);

export const calculateBaseRoute = (loggedIn, permissions = {}, state = {}, isMobile, isLoading) => {
  const currentRoutes = getRouteByRole(loggedIn, permissions, state, isMobile, isLoading);
  const sortedRoutes = currentRoutes.filter(i => !i.hideOnMenu && i.permission[0] !== 'SYSTEM').sort(sortLinksFunction);
  const startRoute = sortedRoutes.find(route => route.path === APP_START_ROUTE);
  window.baseRoute = startRoute?.path || (sortedRoutes && sortedRoutes.length ? sortedRoutes[0].path : '/no-access');
  return window.baseRoute;
};

export const getLayoutByRole = (loggedIn, isMobile = false) => {
  if (!loggedIn) {
    return LoginLayout;
  }
  if (isMobile) {
    return Layout;
  }
  return Layout;
};
